import { render, staticRenderFns } from "./button-main.vue?vue&type=template&id=07c7f286&scoped=true"
import script from "./button-main.vue?vue&type=script&lang=js"
export * from "./button-main.vue?vue&type=script&lang=js"
import style0 from "./button-main.vue?vue&type=style&index=0&id=07c7f286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c7f286",
  null
  
)

export default component.exports